module.exports = __webpack_public_path__ + "img/dashboard.178a76ed.svg";